module.exports = __webpack_public_path__ + "img/132.1f326f8e.jpg";